export const RSS_REQUEST = 'RSS_REQUEST';
export const RSS_REQUEST_SUCCESS = 'RSS_REQUEST_SUCCESS';
export const RSS_REQUEST_ERROR = 'RSS_REQUEST_ERROR';
export const RSS_FEED_URL = 'RSS_FEED_URL';
